var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUserPermission = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 13,
    viewBox: "0 0 10 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.28571 3.44444C7.28571 4.79447 6.26237 5.88889 5 5.88889C3.73763 5.88889 2.71429 4.79447 2.71429 3.44444C2.71429 2.09442 3.73763 1 5 1C6.26237 1 7.28571 2.09442 7.28571 3.44444Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 7.72222C2.79086 7.72222 1 9.63745 1 12H9C9 9.63745 7.20914 7.72222 5 7.72222Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUserPermission);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/userPermission.3b4d2bb8a8671da809ffeeeb2032ac83.svg";